<div *ngIf="buildings.length > 0" class="building-selector">
  <nb-select
    [placeholder]="'All buildings' | translate"
    [(ngModel)]="selectedBuildingId"
    (selectedChange)="onBuildingChange($event)"
    style="min-width: 200px"
  >
    <nb-option *ngFor="let b of buildings" [value]="b.id">{{ b.name }}</nb-option>
  </nb-select>
</div>

<div class="obligations-container">

  <div class="header-container">
    <div class="spreadsheet-filters">
      <span *ngIf="filtersNb > 0" class="filters-nb">{{ 'pages.decision.spreadsheet.header.filters_nb' | translate: { filtersNb: filtersNb } }}</span>
      <span *ngIf="filtersNb > 0" class="filters-button delete" (click)="clearFilters()">{{ 'pages.decision.spreadsheet.header.delete_filters' | translate }}</span>
    </div>
  </div>

  <div class="grid-wrapper">
    <ag-grid-angular
      class="ag-theme-balham ag-grid-kpi"
      [gridOptions]="gridOptions"
      [columnDefs]="columnDefs"
      [rowData]="rows"
      (gridReady)="onGridReady($event)"
    ></ag-grid-angular>
  </div>

</div>
